// src/components/PhotoModal.jsx
import React, { useEffect, useState } from "react";

const PhotoModal = ({ photo, onClose }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!photo) return;

    setFailed(false);

    // Lock scroll
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // ESC to close
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [photo, onClose]);

  const handleBackdropClick = () => onClose();
  const stopPropagation = (e) => e.stopPropagation();

  if (!photo) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      onMouseDown={handleBackdropClick}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

      {/* Modal content */}
      <div
        className="relative z-10 w-full max-w-5xl"
        onMouseDown={stopPropagation}
      >
        {/* Image container */}
        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-black/30 shadow-[0_18px_70px_rgba(0,0,0,0.55)]">
          {failed ? (
            <div className="w-full h-[60vh] flex items-center justify-center text-center px-6">
              <div>
                <p className="text-white/80">Image failed to load</p>
                <p className="mt-2 text-xs text-white/50 break-all">{photo.src}</p>
              </div>
            </div>
          ) : (
            <img
              src={photo.src}
              alt={photo.alt || ""}
              className="w-full max-h-[82vh] object-contain"
              draggable={false}
              loading="eager"
              decoding="async"
              onError={() => setFailed(true)}
            />
          )}
        </div>

        {/* Caption */}
        {photo.caption && (
          <p className="mt-5 text-center italic tracking-wide text-sm text-white/75">
            {photo.caption}
          </p>
        )}
      </div>
    </div>
  );
};

export default PhotoModal;